// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const refinementInFileIdsMax = 10;

export const refinementInInstructionMax = 4000;

export const RefinementIn = zod.object({
  "file_ids": zod.array(zod.uuid()).max(refinementInFileIdsMax).optional(),
  "instruction": zod.string().min(1).max(refinementInInstructionMax)
});

export type RefinementIn = zod.input<typeof RefinementIn>;
export type RefinementInOutput = zod.output<typeof RefinementIn>;
